import React from "react";
import PropTypes from 'prop-types'
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Typography from "@material-ui/core/Typography";
import {Tooltip} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    container: {
        width: '100%',
        textAlign: 'center',
        padding: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
}));


const Header = ({setPanelType, panelType}) => {
    const classes = useStyles();
    const iconLabelType = panelType === 'general' ?
        {label: "Screen Components", icon: "apps", id: 'components'} :
        {label: "Component Settings", icon: "settings", id: 'general'};

    return (
        <div className={classes.container}>
            <div>
            </div>
            <div>
                <Typography color={"textSecondary"}>
                    Screen Designer
                </Typography>
            </div>
            <div style={{display: 'flex', alignItems: 'center'}}>
                <Tooltip title={'Components TreeComponent'}>

                    <IconButton onClick={() => setPanelType('navigator')} size={"small"}>
                        <Icon fontSize={"small"}>
                            account_tree
                        </Icon>
                    </IconButton>
                </Tooltip>
                <Tooltip title={iconLabelType.label}>
                    <IconButton onClick={() => setPanelType(iconLabelType.id)} size={"small"}>
                        <Icon fontSize={"small"}>
                            {iconLabelType.icon}
                        </Icon>
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    )
};

export default Header

Header.propTypes = {
    togglePanelType: PropTypes.func,
    panelType: PropTypes.string
};
